import { initializeApp, FirebaseApp } from 'firebase/app'
import { getAuth, Auth } from 'firebase/auth'
import { getFirestore, Firestore } from 'firebase/firestore'
import {
  getMessaging,
  getToken,
  onMessage,
  Messaging,
} from 'firebase/messaging'

// Check if Firebase config is available
const firebaseConfig = {
  apiKey: import.meta.env?.VITE_FIREBASE_API_KEY || '',
  authDomain: import.meta.env?.VITE_FIREBASE_AUTH_DOMAIN || '',
  projectId: import.meta.env?.VITE_FIREBASE_PROJECT_ID || '',
  storageBucket: import.meta.env?.VITE_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: import.meta.env?.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env?.VITE_FIREBASE_APP_ID || '',
}

// Check if Firebase is configured
const isFirebaseConfigured = firebaseConfig.apiKey && firebaseConfig.projectId

let app: FirebaseApp | null = null
let auth: Auth | null = null
let db: Firestore | null = null
let messaging: Messaging | null = null

if (isFirebaseConfigured) {
  try {
    app = initializeApp(firebaseConfig)
    auth = getAuth(app)
    db = getFirestore(app)

    if (typeof window !== 'undefined') {
      try {
        messaging = getMessaging(app)
      } catch (e) {
        console.warn('Firebase Messaging not available:', e)
      }
    }
  } catch (error) {
    console.error('Firebase initialization error:', error)
  }
} else {
  console.warn(
    'Firebase not configured. Running in local-only mode. Add environment variables to enable backend features.',
  )
}

export { auth, db, messaging }

// Request notification permission
export const requestNotificationPermission = async () => {
  if (!messaging) {
    console.warn('Firebase Messaging not initialized')
    return null
  }

  try {
    const permission = await Notification.requestPermission()

    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: import.meta.env?.VITE_FIREBASE_VAPID_KEY,
      })

      console.log('FCM Token:', token)
      return token
    }
  } catch (error) {
    console.error('Error getting notification permission:', error)
    return null
  }
}

// Listen for foreground messages
if (messaging) {
  onMessage(messaging, (payload) => {
    console.log('Message received:', payload)

    // Show browser notification
    if (payload.notification) {
      new Notification(payload.notification.title || 'Quest App', {
        body: payload.notification.body,
        icon: '/logo192.png',
      })
    }
  })
}

export const isFirebaseEnabled = isFirebaseConfigured
